<template>
  <div class="list">
  <div class="breadcrumb">
    <Breadcrumb>
      <Breadcrumb-item>订单管理</Breadcrumb-item>
      <Breadcrumb-item>出单节奏图</Breadcrumb-item>
    </Breadcrumb>
  </div>
  <div class="search" @keyup.enter="search">
    <Form :label-width="80" :show-message="false">
      <Row gutter="12">
        <i-col :xs="24" :sm="12" :md="6" :lg="4">
          <Form-item label="开始日期">
            <Date-picker
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="选择开始日期"
              @on-change="onStartDateChange">
            </Date-picker>
          </Form-item>
        </i-col>
        <i-col :xs="24" :sm="12" :md="6" :lg="4">
          <Form-item label="部门">
            <Select
              v-model="queryParam.adviserGroup"
              placeholder="请选择部门"
              clearable
              @on-change="search"
              style="width: 100%">
              <Option
                v-for="item in adviserGroupList"
                :key="item.code"
                :value="item.code">
                {{ item.text }}
              </Option>
            </Select>
          </Form-item>
        </i-col>
        <i-col :xs="24" :sm="12" :md="6" :lg="4">
          <Form-item label="课程顾问" prop="adviserId">
            <admin-user-select :status="1" adminGroupCode="adviser" v-model="queryParam.adviserId">
            </admin-user-select>
          </Form-item>
        </i-col>
      </Row>
    </Form>
  </div>
  <div class="table-container">
    <Row class="form-search">
      <i-col :xs="8" :sm="8" :md="8">
        <Form-item label="月份">
          <DatePicker v-model="queryParam.month" type="month" format="yyyy-MM" placeholder="选择月份" @on-change="search"/>
        </Form-item>
      </i-col>
      <i-col :xs="4" :sm="4" :md="4" offset="1">
        <Button type="primary" :loading="searchLoading" icon="search" @click="search">搜索</Button>
        <Button type="primary" :loading="exportLoading" :disabled="exportLoading" icon="ios-download" @click="exportData" style="margin-left: 10px;">导出</Button>
      </i-col>
    </Row>

    <Table class="compact" size="small" :columns="columns" :data="dataList" :loading="searchLoading"></Table>
  </div>
  </div>
</template>

<script>
export default {
  name: 'DragonTigerList',
  data() {
    return {
      searchLoading: false,
      exportLoading: false,
      queryParam: {
        month: this.$moment().format('YYYY-MM'),
        adviserGroup: '',
        adviserId: ''
      },
      dataList: [],
      adviserGroupList: this.$constant.adviserGroup,
    }
  },
  created() {
    this.search()
  },
  watch: {
    'queryParam.adviserId' (newVal) {
      // 避免初始化和清空时触发搜索
      if (this.searchLoading) return
      this.search()
    }
  },
  methods: {
    search() {
      this.searchLoading = true
      const month = this.$moment(this.queryParam.month).format('YYYY-MM')
      this.$http.get('/fundPackage/dragonTigerList', {
        params: {
          month: month,
          adviserGroup: this.queryParam.adviserGroup || null,
          adviserId: this.queryParam.adviserId || null
        }
      }).then(res => {
        if (res && res.data) {
          this.dataList = this.processData(res.data)
        }
        this.searchLoading = false
      }).catch(() => {
        this.searchLoading = false
      })
    },
    processData(data) {
      // 处理数据，将每个顾问的数据分成两行：单量和金额
      const result = []
      if (!data || !data.length) {
        return result
      }

      data.forEach((item, index) => {
        // 单量行
        const quantityRow = {
          type: 'quantity',
          adviserName: '',
          target: item.target,
          completed: item.completed,
          index: index,
          tchChannel: item.tchChannel
        }
        // 金额行
        const amountRow = {
          type: 'amount',
          adviserName: item.adviserName,
          target: item.totalAmount,
          completed: item.completedAmount,
          index: index,
          tchChannel: item.tchChannel
        }

        // 复制每天的数据
        for (let i = 1; i <= 31; i++) {
          const dayKey = 'day' + i
          const dayData = item['day' + i]
          quantityRow[dayKey] = dayData ? dayData.count : 0
          amountRow[dayKey] = dayData ? dayData.amount : 0
        }

        result.push(quantityRow)
        result.push(amountRow)
      })

      return result
    },
    onStartDateChange (value) {
      // 将日期转换为 yyyy-MM-dd 格式
      if (value) {
        this.queryParam.month = this.$moment(value).format('YYYY-MM')
      } else {
        this.queryParam.month = ''
      }
    },
    exportData () {
      this.exportLoading = true
      const month = this.$moment(this.queryParam.month).format('YYYY-MM')
      this.$http.get('/fundPackage/dragonTigerList/export', {
        responseType: 'arraybuffer',
        params: {
          month: month,
          adviserGroup: this.queryParam.adviserGroup || null,
          adviserId: this.queryParam.adviserId || null
        }
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = `出单节奏图-${month}.xlsx`
          link.click()
          this.$Message.success('导出成功')
        } else {
          this.$Message.error(response.msg || '导出失败')
        }
        this.exportLoading = false
      }).catch((error) => {
        this.$Message.error('导出失败：' + error.message)
        this.exportLoading = false
      })
    },
  },
  computed: {
    columns() {
      const monthName = this.$moment(this.queryParam.month).format('M 月份')
      const $moment = this.$moment
      const $numeral = this.$numeral

      return [
        {
          title: `${monthName}`,
          align: 'center',
          width: 100,
          fixed: 'left',
          renderHeader: (h) => h('div', {style: {fontStyle: 'italic', textAlign: 'center', boxSizing: 'border-box', color: '#000', fontWeight: 'bold', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center'}}, `${monthName}`),
          render: (h, params) => {
            // 在金额行显示姓名，这样视觉上在单量和金额中间
            if (params.row.type === 'amount') {
              return h('b', {
                style: {
                  fontSize: '14px'
                }
              }, params.row.adviserName || '')
            }
            // 单量行不显示
            return h('span')
          }
        },
        {
          title: '#',
          align: 'center',
          width: 60,
          fixed: 'left',
          renderHeader: (h) => h('div', {style: {fontStyle: 'italic', textAlign: 'center', boxSizing: 'border-box', color: '#000', fontWeight: 'bold', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center'}}, '#'),
          render: (h, params) => {
            // 显示单量或金额标签
            const label = params.row.type === 'quantity' ? '单量' : '金额'
            return h('span', {style: {fontWeight: 'bold'}}, label)
          }
        },
        {
          title: '目标',
          align: 'center',
          width: 80,
          fixed: 'left',
          renderHeader: (h) => h('div', {style: {fontStyle: 'italic', textAlign: 'center', boxSizing: 'border-box', color: '#000', fontWeight: 'bold', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}, '目标'),
          render: (h, params) => {
            if (params.row.type === 'amount') {
              return h('span', {style: {fontWeight: 'bold', fontSize: '14px'}},
                params.row.target ? $numeral(params.row.target).format('0') : '')
            }
            return h('span', {style: {fontWeight: 'bold', fontSize: '14px'}}, params.row.target)
          }
        },
        {
          title: '完成',
          align: 'center',
          width: 100,
          fixed: 'left',
          renderHeader: (h) => h('div', {style: {fontStyle: 'italic', textAlign: 'center', boxSizing: 'border-box', color: '#000', fontWeight: 'bold', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}, '完成'),
          render: (h, params) => {
            if (params.row.type === 'amount') {
              return h('span', {style: {color: '#19be6b', 'font-weight': 'bold', fontSize: '16px'}},
                params.row.completed ? $numeral(params.row.completed).format('0') : '')
            }
            return h('span', {style: {color: '#19be6b', 'font-weight': 'bold', fontSize: '14px'}}, params.row.completed)
          }
        },
        ...Array.from({length: 31}, (_, i) => ({
          title: (i + 1).toString(),
          key: 'day' + (i + 1),
          align: 'center',
          width: 65,
          renderHeader: (h) => h('div', {style: {fontStyle: 'italic', borderRight: '1px solid #000', padding: '8px', textAlign: 'center', boxSizing: 'border-box', color: '#000', fontWeight: 'bold', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}, (i + 1).toString() + '日'),
          render: (h, params) => {
            const row = params.row
            const value = row['day' + (i + 1)]
            let bgColor = '#fff'
            let fontColor = '#000'

            if (value && value > 0) {
              const colors = [
                {bg: '#ffe6e6', font: '#333'},
                {bg: '#e6f3ff', font: '#333'},
                {bg: '#e6ffe6', font: '#333'},
                {bg: '#fff4e6', font: '#333'},
                {bg: '#f0e6ff', font: '#333'},
                {bg: '#ffe6f0', font: '#333'}
              ]
              const colorInfo = colors[row.index % colors.length]
              bgColor = colorInfo.bg
              fontColor = colorInfo.font
            }

            if (row.type === 'amount' && value) {
              return h('div', {
                style: {
                  backgroundColor: bgColor,
                  padding: '5px',
                  color: fontColor,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  borderRight: '1px solid #000',
                  height: '100%',
                  boxSizing: 'border-box'
                }
              }, $numeral(value).format('0'))
            }

            return h('div', {
              style: {
                backgroundColor: bgColor,
                padding: '5px',
                color: fontColor,
                textAlign: 'center',
                borderRight: '1px solid #000',
                height: '100%',
                boxSizing: 'border-box'
              }
            }, value || '')
          }
        }))
      ]
    }
  }
}
</script>

<style scoped>
.form-search {
  margin-bottom: 10px;
}

// 表格边框样式 - Excel 风格
/deep/ .ivu-table-wrapper {
  border: 1px solid #000;
}

// 所有单元格边框
/deep/ .ivu-table th,
/deep/ .ivu-table td {
  border-right: 1px solid #000 !important;
  border-bottom: 1px solid #000 !important;
}

// 表格内容居中
/deep/ .ivu-table-cell {
  text-align: center !important;
}

// 确保单元格内内容垂直居中
/deep/ .ivu-table-cell {
  vertical-align: middle !important;
}

// 单量行（奇数行）整行背景色 - 淡蓝色
/deep/ .ivu-table-body tr:nth-child(2n-1) td,
/deep/ .ivu-table-fixed-body tr:nth-child(2n-1) td {
  background-color: #ebf7ff !important;
}

// 金额行（偶数行）整行背景色 - 淡灰色
/deep/ .ivu-table-body tr:nth-child(2n) td,
/deep/ .ivu-table-fixed-body tr:nth-child(2n) td {
  background-color: #f5f5f5 !important;
}

</style>



// WEBPACK FOOTER //
// DragonTigerList.vue?60bfeb28